
import {StoreBase} from "shared/core/Store/StoreBase";
import {SingleEvent} from "shared/core/Events/SingleEvent";

export abstract class ModelBase<Op extends StoreBase> {
    public Options:Op;
    public OnRefresh:SingleEvent;
    constructor(Options:Op){
        this.Options=Options;
        this.OnRefresh=new SingleEvent();
    }

    public Refresh(){
        this.OnRefresh.Publish();
    }

    protected SerializeProperty(propertyName:string){
        return null;
    }

    public GetOptions():any{
        let objectToReturn=this.Options.ToObject();
        for(let propertyName in this)
        {
            if(!(this as object).hasOwnProperty(propertyName))
                continue;
            if((this as any)._modelSerialize!=null&&(this as any)._modelSerialize[propertyName]!=null)
            {
                let serialized=this.SerializeProperty(propertyName);
                if(serialized!=null) {
                    objectToReturn[propertyName] = serialized;
                    continue;
                }

                if(Array.isArray(this[propertyName]))
                {
                    objectToReturn[propertyName]=[];
                    for(let model of this[propertyName] as any)
                        (objectToReturn[propertyName] as any[]).push(model.GetOptions())
                }else
                    if(this[propertyName]==null)
                        objectToReturn[propertyName]=null;
                    else
                        objectToReturn[propertyName]=(this[propertyName] as any).GetOptions();
            }
        }

        return objectToReturn;
    }
}


export function ModelSerialize():any {
    return function decorator(target,key,descriptor){
        if(target._modelSerialize==null)
            target._modelSerialize={};
        target._modelSerialize[key]=true;
    }

}

